<template>
  <agenda-card :startTime="startTime" :endTime="endTime" :hasCollapse="!!description">
    <template>
      <p class="is-size-6 has-text-grey has-text-weight-semibold">{{ location }}</p>
      <profile-media :picture="picture" :firstName="firstName" :lastName="lastName" :position="position" :company="company"></profile-media>
    </template>

    <template #actions>
      <div class="columns is-gapless is-vcentered">
        <!-- Video call link -->
        <div v-if="callUrl" class="column ml-1">
          <a class="is-block" target="_blank" :href="callUrl" @click.stop rel="noopener noreferrer">
            <videocam-icon class="is-block videocam-icon"></videocam-icon>
          </a>
        </div>
      </div>
    </template>

    <template #collapse>
      <div class="content">
        <p>{{ description }}</p>
      </div>
    </template>

    <template #right>
      <div style="padding: 24px">
      </div>
    </template>
  </agenda-card>
</template>

<script>
import VideocamIcon from "@/assets/icons/videocam.svg";
import AgendaCard from "@/shared/components/agenda/AgendaCard";
import ProfileMedia from "@/widgets/agenda/components/shared/ProfileMedia";
import Constants from "@/widgets/shared/constants";

export default {
  name: "AgendaMeeting",

  props: ["meeting"],

  components: {
    VideocamIcon,
    AgendaCard,
    ProfileMedia
  },

  computed: {
    startTime() {
      return this.meeting.time_start;
    },

    endTime() {
      return this.meeting.time_end;
    },

    location() {
      if (this.meeting.tag_agenda_place) {
        return this.meeting.tag_agenda_place.value;
      } else {
        return this.meeting.custom_place_name;
      }
    },

    description() {
      return this.meeting.message;
    },

    source() {
      // Choose source person based on meeting type
      if (this.meeting.type === "ingoing") {
        return this.meeting.from_user;
      } else {
        return this.meeting.to_user;
      }
    },

    picture() {
      return this.source.picture;
    },

    firstName() {
      return this.source.first_name;
    },

    lastName() {
      return this.source.last_name;
    },

    position() {
      return this.source.position;
    },

    company() {
      return this.source.company;
    },

    callUrl() {
      const roomId = selectRoomId(this.meeting);
      const url = `${Constants.JITSI_URL}/${roomId}`;

      return url;
    }
  }
};

function selectRoomId(meeting) {
  const from = meeting.from_user.user_identity_token;
  const to = meeting.to_user.user_identity_token;

  if (from.toLowerCase() < to.toLowerCase()) {
    return `users_${from}_${to}`;
  } else {
    return `users_${to}_${from}`;
  }
}
</script>

<style lang="scss" scoped>
.videocam-icon {
  fill: var(--primary-color);
}
</style>
